export const CheckSentIcon = ({ size = 24 }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 12.5L6.66667 16.1667L15.8333 7M9 12.5L12.6667 16.1667L21.8333 7"
      stroke="#8E9BA1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
